import { db } from "../firebase/firebase";
import {
  collection,
  getDocs,
  query,
  where,
  addDoc,
  serverTimestamp
} from "firebase/firestore";

export const fetchResultsByUser = async (userId) => {
  const q = query(
    collection(db, "results"),
    where("userId", "==", userId)
  );

  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
};

export const saveResultToDb = async (data) => {
  await addDoc(collection(db, "results"), {
    ...data,
    createdAt: serverTimestamp()
  });
};
